 
export const UPLOAD_IMAGE_REQUEST='UPLOADIMAGECOMPONENT/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS='UPLOADIMAGECOMPONENT/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAIL='UPLOADIMAGECOMPONENT/UPLOAD_IMAGE_FAIL';
export const UPLOAD_IMAGE_RESET='UPLOADIMAGECOMPONENT/UPLOAD_IMAGE_RESET';
export const DEFAULT_IMAGE='UPLOADIMAGECOMPONENT/DEFAULT_IMAGE';
